export default __webpack_public_path__ + "static/media/trash-icon.ea65dc7c.svg";